import termsSource from '../../../../legal/TERMS_OF_SERVICE.md?raw';
import privacySource from '../../../../legal/PRIVACY_POLICY.md?raw';
import aupSource from '../../../../legal/ACCEPTABLE_USE_POLICY.md?raw';

/** Operator values used to publish the /legal templates on this instance. */
export const LEGAL_OPERATOR = {
  COMPANY_LEGAL_NAME: 'the BirdMan operator',
  COMPANY_TRADING_NAME: 'BirdMan',
  COMPANY_REG_NUMBER: 'to be confirmed',
  COMPANY_ADDRESS: 'Correspondence via support@birdmansuite.com',
  COMPANY_COUNTRY: 'South Africa',
  WEBSITE_URL: 'https://birdmansuite.com',
  SUPPORT_EMAIL: 'support@birdmansuite.com',
  PRIVACY_EMAIL: 'privacy@birdmansuite.com',
  LEGAL_EMAIL: 'legal@birdmansuite.com',
  GOVERNING_LAW: 'the Republic of South Africa',
  COURTS_JURISDICTION: 'the courts of South Africa',
  EFFECTIVE_DATE: '18 August 2026',
  INFO_OFFICER_NAME: 'Information Officer',
  DATA_RETENTION_PERIOD: '30 days',
} as const;

export type LegalSlug = 'terms' | 'privacy' | 'aup';

export interface LegalDocument {
  slug: LegalSlug;
  title: string;
  markdown: string;
}

function applyPlaceholders(source: string): string {
  return source.replace(/\{\{([A-Z_]+)\}\}/g, (match, key: string) => {
    const value = LEGAL_OPERATOR[key as keyof typeof LEGAL_OPERATOR];
    return value ?? match;
  });
}

export const LEGAL_DOCUMENTS: Record<LegalSlug, LegalDocument> = {
  terms: {
    slug: 'terms',
    title: 'Terms of Service',
    markdown: applyPlaceholders(termsSource),
  },
  privacy: {
    slug: 'privacy',
    title: 'Privacy Policy',
    markdown: applyPlaceholders(privacySource),
  },
  aup: {
    slug: 'aup',
    title: 'Acceptable Use Policy',
    markdown: applyPlaceholders(aupSource),
  },
};

export function getLegalDocument(slug: string | undefined): LegalDocument | undefined {
  if (!slug) return undefined;
  if (slug === 'terms' || slug === 'privacy' || slug === 'aup') {
    return LEGAL_DOCUMENTS[slug];
  }
  return undefined;
}
